import { render, staticRenderFns } from "./UsuarioexpedienteAutomodal.vue?vue&type=template&id=748fda2a&"
import script from "./UsuarioexpedienteAutomodal.vue?vue&type=script&lang=js&"
export * from "./UsuarioexpedienteAutomodal.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioexpedienteAutomodal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports